import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { ActionFieldType } from '../constants/caseActions';


export interface CaseActionFieldObject {
  id: number;
  title: string;
  isMandatory: boolean;
  isEditable: boolean;
  isDefault: boolean;
  checked: boolean;
  isDisplayed: boolean;
  order: number | null;
  fieldType: ActionFieldType;
  dropdownChoices?: string[];
  predefinedChoices?: string[];
}

type CaseActionsState = {
  items: Array<CaseActionFieldObject>,
  isRequestRunning: boolean,
};
const initialState: CaseActionsState = {
  items: [],
  isRequestRunning: false,
};

export const caseActionsSlice = createSlice({
  name: 'caseActions',
  initialState,
  reducers: {
    setItems: (state, action: PayloadAction<Array<CaseActionFieldObject>>) => {
      state.items = action.payload;
    },
    setIsRequestRunning: (state, action: PayloadAction<boolean>) => {
      state.isRequestRunning = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setItems,
  setIsRequestRunning,
} = caseActionsSlice.actions;

export default caseActionsSlice.reducer;